export const ONLYFY_URL_DE = 'https://onlyfy.com/de';
export const ONLYFY_URL_EN = 'https://onlyfy.com/en';

export const TWELVE_WEEK_SHORTLIST = '12';

export const QUERY_STRING_PRODUCT = 'product';
export const QUERY_STRING_DURATION = 'duration';
